import Vue from 'vue'

export default {
    UPDATE_EVENTS (state, value) {
        Vue.set(state, 'events', value);
    },
    SET_EVENTS (state, value) {
        this.commit('UPDATE_EVENTS', value);
    },
    SET_SELECTED_EVENT (state,  value ) {
      Vue.set(state, 'selectedEvent', value);
    },
    SET_DEMO_EVENT (state,  value ) {
      Vue.set(state, 'demoEvent', value);
    },
    SET_EMAIL_TEMPLATE (state,  value ) {
      Vue.set(state, 'emailTemplate', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/events/mutations.js